import { Component } from '@angular/core';

@Component({
  selector: 'app-company-modifications',
  templateUrl: './company-modifications.component.html',
  styleUrl: './company-modifications.component.scss'
})
export class CompanyModificationsComponent {

}
